import React, { createContext, useContext, useRef, useState } from "react";
import axiosInstance, { handleApiError } from "../services/axiosService";
import { useTreeContext } from "./TreeDataContext";
import { createChecksum } from "../commonFunctions/fileFolderConfig";
import { useAppOrgContext } from "./AppOrgContext";
import { useParams } from "react-router-dom";
import { processLayout } from "../utils/GridLayoutFunc";
import { useFormContext } from "./FormContext";
import { getTreeDataForPublicScreens } from "../utils/treeData/treeDataUtils";
// import { useAppOrgContext } from './AppOrgContext';

const PublicScreenContextApi = createContext();
const usePublicScreenContext = () => useContext(PublicScreenContextApi);

const PublicScreenContext = ({ children }) => {
  const [selectedPublicScreen, setSelectedPublicScreen] = useState({
    id: "",
    name: "",
    parentData: ""
  });

  const [layouts, setLayouts] = useState([]);
  const layoutData = useRef({});
  const nestedGridData = useRef({});

  const [currentPublicScreenData, setCurrentPublicScreenData] = useState({});

  const { currentChecksum } = useAppOrgContext();
  const { setPublicAccessExplorerData } = useTreeContext();
  const { renderFieldsData, renderFieldsArray } = useFormContext();
  const [allPublicForms, setAllPublicForm] = useState([]);

  const { publicId } = useParams();

  const fetchAllPublicScreens = async () => {
    const { data: screenData } = await axiosInstance.get(`/public-screens`);
    const { data: formData } = await axiosInstance.get(`/public-screen-form`);
    // setAllPublicForm(formData)
    const treeData = getTreeDataForPublicScreens({ ...screenData, form: formData });
    setPublicAccessExplorerData(treeData);
    return { screenData, treeData };
  };

  const savePublicScreenJson = async () => {
    let config = getPublicAccessConfig();
    // let body = {};
    try {
      if (selectedPublicScreen.parentData === "publicform") {
        const { message } = await axiosInstance.patch(`/public-screen-form/${publicId}`, config);
        const newChecksum = createChecksum(config);
        currentChecksum.current = newChecksum;
        return { data: config, message };
      } else {
        // body = ;
        const { message } = await axiosInstance.patch(`/public-screens/${publicId}`, config);
        const newChecksum = createChecksum(config);
        currentChecksum.current = newChecksum;
        return { data: config, message };
      }
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  };

  const getPublicAccessConfig = () => {
    const type = selectedPublicScreen.parentData;
    switch (type) {
      case "publicform":
        return getPublicFormConfig();

      default:
        return getPublicScreenConfig();
    }
  };
  const getPublicFormConfig = () => {
    const arrayCopy = [...renderFieldsArray];
    arrayCopy.sort((a, b) => a.y - b.y);

    //handle all outer field in form
    const newArray = arrayCopy.map((field) => {
      return renderFieldsData.current[field.i];
    });
    return {
      custom_js: currentPublicScreenData.custom_js,
      submit_button: currentPublicScreenData.submit_button,
      fields: newArray
    };
  };

  const getPublicScreenConfig = () => {
    const newLayoutsArray = [...layouts];
    let { elements } = processLayout(layoutData, nestedGridData, newLayoutsArray);
    return {
      config: { layout: elements }
    };
  };

  return (
    <PublicScreenContextApi.Provider
      value={{
        selectedPublicScreen,
        setSelectedPublicScreen,
        layoutData,
        layouts,
        nestedGridData,
        setLayouts,
        fetchAllPublicScreens,
        currentPublicScreenData,
        setCurrentPublicScreenData,
        savePublicScreenJson,
        getPublicScreenConfig,
        getPublicFormConfig,
        getPublicAccessConfig,
        allPublicForms,
        setAllPublicForm
      }}
    >
      {children}
    </PublicScreenContextApi.Provider>
  );
};

export default PublicScreenContext;
export { usePublicScreenContext };
